// Object.hasOwn для совместимости с ES2020
if (!Object.hasOwn) {
  Object.defineProperty(Object, 'hasOwn', {
    value: function (obj: object, prop: PropertyKey): boolean {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    },
    writable: true,
    configurable: true,
  });
}
